"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBackendArrearsSubmissionPayload = exports.arrearsSubmissionBackendSchema = void 0;
// Arrears Submission - Back End Schema Validator
var schema_validator_1 = require("@hobt/schema-validator");
var arrears_submission_frontend_schema_1 = require("./arrears-submission-frontend-schema");
exports.arrearsSubmissionBackendSchema = __assign(__assign(__assign({}, arrears_submission_frontend_schema_1.arrearsSubmissionFrontendSchema), arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema), { properties: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsSubmissionFrontendSchema.properties), { submission: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsSubmissionFrontendSchema.properties.submission), { required: __spreadArrays(arrears_submission_frontend_schema_1.arrearsSubmissionFrontendSchema.properties.submission.required, [
                'recordCreatedTimestamp',
                'recordCreatedUserID',
                'recordUpdatedTimestamp',
                'recordUpdatedUserID',
                'statusCode',
            ]) }), arrearsFiles: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles), { items: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles.items), { required: __spreadArrays(arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles.items.required, [
                    'recordCreatedTimestamp',
                    'recordCreatedUserID',
                    'recordUpdatedTimestamp',
                    'recordUpdatedUserID',
                    'statusUpdatedTimestamp',
                    'statusCode',
                ]), properties: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles.items.properties), { attachment: __assign(__assign({}, arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles.items.properties
                        .attachment), { required: __spreadArrays(arrears_submission_frontend_schema_1.arrearsFilesFrontendSchema.properties.arrearsFiles.items.properties
                            .attachment.required, [
                            'recordCreatedTimestamp',
                            'submitterUserID',
                            'submitterUserTypeCode',
                            'uploadStatusCode',
                        ]) }) }) }) }) }) });
/**
 * Validate that the Arrears Form Submission has the correct schema
 * @param arrearsForm
 */
exports.validateBackendArrearsSubmissionPayload = function (arrearsForm) {
    var arrearsFormValidator = new schema_validator_1.SchemaValidator(exports.arrearsSubmissionBackendSchema, true, false, true, true);
    arrearsFormValidator.validate(arrearsForm);
};
